const en = require('./prompts/prompts.en');
const it = require('./prompts/prompts.it');

function getPromptFunction(fnName, language) {
  console.log('fnName', fnName, 'language', language);
  if (language === 'it' && typeof it[fnName] === 'function') {
    return it[fnName];
  }
  // Default to English if not Italian or not found
  return en[fnName];
}

// Proxy all exported functions to delegate based on language
const exported = {};
for (const fnName of Object.keys(en)) {
  exported[fnName] = (...args) => {
    // Assume language is always the last argument
    const language = args[args.length - 1];
    const fn = getPromptFunction(fnName, language);
    return fn(...args);
  };
}
module.exports = exported;